import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareV = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler33') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler33', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Dagonhai robe!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Dagonhai robe!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareV}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareV
  
